<template>
  <div class="dashboard">
    <el-tabs v-model="activeTab" class="h-full">
      <el-tab-pane label="Tenants" name="tenants">
        <Tenants />
      </el-tab-pane>
      <el-tab-pane label="Traces" name="traces" lazy>
        <Traces />
      </el-tab-pane>
      <el-tab-pane label="Emails" name="emails" lazy>
        <Emails />
      </el-tab-pane>
      <el-tab-pane label="Document AI" name="document-ai" lazy>
        <DocumentAi />
      </el-tab-pane>
      <el-tab-pane label="Settings" name="settings" lazy>
        <Settings />
      </el-tab-pane>
      <el-tab-pane label="Tickets" name="tickets" lazy>
        <ticket-board system />
      </el-tab-pane>
      <el-tab-pane label="Guides" name="guides" lazy>
        <Guides />
      </el-tab-pane>
      <el-tab-pane label="Monitor" name="monitor" lazy>
        <iframe class="w-full h-[calc(100vh_-_110px)]" src="/sidekiq" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Tenants from "@/system/pages/tenants.vue";
import Traces from "@/system/pages/traces.vue";
import Emails from "@/system/pages/emails.vue";
import DocumentAi from "@/system/pages/document/ai/widget.vue";
import Settings from "@/system/pages/settings.vue";
import TicketBoard from "@/default/pages/tickets/board.vue";
import Guides from "@/system/pages/guides.vue";

export default {
  name: "Dashboard",
  components: {
    Tenants,
    Traces,
    Emails,
    DocumentAi,
    Settings,
    TicketBoard,
    Guides,
  },
  data() {
    return {
      activeTab:
        new URLSearchParams(window.location.search.replace(/^\?+/, "")).get(
          "tab"
        ) || "tenants",
    };
  },
};
</script>
<style lang="scss" scoped>
.dashboard::v-deep {
  @apply h-[calc(100vh_-_50px)];
  & > .el-tabs > .el-tabs__content {
    @apply px-2 h-[calc(100vh_-_105px)] overflow-auto;
  }
}
</style>
